/**
 * Backend (createTransfer) przy dołączaniu loszki remontowej do grupy, gdy wcześniej
 * nie należała do żadnej grupy, zapisuje w evencie przeniesienia
 * `OldGroupID = AnmID` (ID zwierzęcia, nie grupy) oraz `NewGroupID = grupa docelowa`.
 * Takie przeniesienie NIE jest przeniesieniem z innej grupy - trzeba je traktować
 * jak zwykłe przeniesienie w obrębie grupy.
 * @param event {object} event przeniesienia (EvCode "T")
 * @return {boolean}
 */
export function isGiltJoinedGroupTransfer(event) {
    const OldGroupID = event?.EvData?.OldGroupID;
    return !!OldGroupID && OldGroupID === event?.AnmID;
}

/**
 * Zwraca informacje o grupach z eventu przeniesienia z pominięciem przypadku,
 * gdy `OldGroupID` jest tak naprawdę ID zwierzęcia (patrz {@link isGiltJoinedGroupTransfer}).
 * W takim przypadku wszystkie pola są `undefined`, czyli event zachowuje się jak
 * zwykłe przeniesienie między lokalizacjami w tej samej grupie.
 * @param event {object} event przeniesienia (EvCode "T")
 * @return {{OldGroupID: (string|undefined), NewGroupID: (string|undefined), GroupTransfer: (string|undefined)}}
 */
export function getTransferGroupData(event) {
    if (isGiltJoinedGroupTransfer(event)) {
        return {
            OldGroupID: undefined,
            NewGroupID: undefined,
            GroupTransfer: undefined,
        };
    }
    const {OldGroupID, NewGroupID, GroupTransfer} = event?.EvData || {};
    return {OldGroupID, NewGroupID, GroupTransfer};
}

/**
 * Zwraca kopię eventu bez `OldGroupID`, jeśli jest to tak naprawdę ID zwierzęcia
 * (patrz {@link isGiltJoinedGroupTransfer}); pozostałe eventy zwraca bez zmian.
 * Do użycia przed `getAnimalTimespanInGroupByAllEvents` z `@wesstron/utils`, żeby loszka
 * nie była traktowana jako "spoza grupy" przed takim przeniesieniem (bez tego wypadają
 * z karty grupy wszystkie jej eventy sprzed przeniesienia, np. wprowadzenie).
 * @param event {object}
 * @return {object}
 */
export function normalizeTransferEventGroupData(event) {
    if (!isGiltJoinedGroupTransfer(event)) return event;
    const {OldGroupID, ...EvData} = event.EvData;
    return {...event, EvData};
}

/**
 * @see normalizeTransferEventGroupData
 * @param events {object[]}
 * @return {object[]}
 */
export function normalizeTransferEventsGroupData(events = []) {
    return events.map(normalizeTransferEventGroupData);
}
